import { render, staticRenderFns } from "./EditUtilisateurDroits.vue?vue&type=template&id=119d72d3&"
import script from "./EditUtilisateurDroits.vue?vue&type=script&lang=ts&"
export * from "./EditUtilisateurDroits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports